import React from 'react';
import { TechArea, skillColor } from './constants';

const TypeBox = ({ type, category }) => {
  const filteredTechArea = TechArea.filter((tech) => tech.type === type);
  const skillLevels = filteredTechArea.reduce((accumulator, skill) => {
    const existingLevel = accumulator.find(
      (item) => item.level === skill.level
    );
    if (existingLevel) {
      existingLevel.skills.push(skill);
    } else {
      accumulator.push({
        level: skill.level,
        skills: [skill],
      });
    }
    return accumulator;
  }, []);

  const sortedSkillLevels = skillLevels.sort((a, b) => b.level - a.level);

  const isMobileSize = window.innerWidth <= 768;

  return (
    <div style={styles.typeBox}>
      <div style={styles.typeBoxHeading}>{type}</div>
      <div
        style={{ ...styles.skills, ...(isMobileSize && mobileStyles.skills) }}
      >
        {sortedSkillLevels.map((levelData) => (
          <div key={levelData.level} style={styles.skillBoxWrapper}>
            <div
              key={levelData.level}
              style={{
                ...styles.skillBox,
                // height: `${levelData.level * 35}px`,
                // height: `${
                //   levelData.level !== 3
                //     ? levelData.level * 28
                //     : levelData.level * 20
                // }px`,
                padding: `${levelData.level !== 3 ? 0 : 5}px`,
                boxShadow:
                  levelData.level !== 3
                    ? '0 0 5px rgba(0, 0, 0, 0.3)'
                    : '0 0 5px rgba(0, 0, 0, 0.9)',
                // : '0 0 5px rgba(0, 0, 0, 0.3), linear-gradient(45deg, #C13584, #8134AF, #405DE6, #5851DB)',
                // '0 0 5px rgba(0, 0, 0, 0.3), 0 0 5px 3px rgba(193, 53, 132, 0.3), 0 0 5px 6px rgba(129, 52, 175, 0.3), 0 0 5px 9px rgba(64, 93, 230, 0.3), 0 0 5px 12px rgba(88, 81, 219, 0.3)',
              }}
            >
              {levelData.skills.map((skill) => (
                <div key={skill.name} style={styles.skillEntry}>
                  <span style={styles.skillIcon}>
                    {/* <IconContext.Provider value={{ color: 'blue', size: '50px' }}> */}
                    {React.createElement(skill.iconName, {
                      size: skill.level === 3 ? 24 : 14,
                      color:
                        category.toLowerCase() === 'all' ||
                        skill.category.includes(category)
                          ? skillColor
                          : // 'linear-gradient(45deg, #C13584, #8134AF, #405DE6, #5851DB)'
                            'black',
                    })}
                    {/* </IconContext.Provider> */}
                  </span>
                  <div
                    style={{
                      fontSize: skill.level !== 3 ? '12px' : 'inherit',
                      // fontWeight:
                      //   category.toLowerCase() === 'all' ||
                      //   skill.category.includes(category)
                      //     ? 'bold'
                      //     : 'normal',
                      color:
                        category.toLowerCase() === 'all' ||
                        skill.category.includes(category)
                          ? skillColor
                          : // 'linear-gradient(45deg, #C13584, #8134AF, #405DE6, #5851DB)'
                            'black',
                    }}
                  >
                    {skill.name}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  typeBox: {
    padding: '16px',
    // border: '2px solid black',
    borderRadius: '4px',
  },
  typeBoxHeading: {
    marginBottom: '8px',
    fontWeight: 'bold',
  },
  skills: {
    display: 'flex',
    flexDirection: 'row', // to display skills next to each other
    flexWrap: 'wrap', // Wrap skills to the next line
    justifyContent: 'center', // Horizontally center
    // border: '1px solid blue',
  },
  skillBoxWrapper: {
    // display: 'block',
    // marginBottom: '5px',
    // display: 'flex',
    // flexDirection: 'column',
    // display: 'inline-block',
    // boxShadow: '0 0 5px rgba(0, 0, 0, 0.3)', // a shadow effect
    // borderRadius: '4px',
  },
  skillBox: {
    display: 'flex',
    marginBottom: '5px',
    marginRight: '5px',
    boxShadow: '0 0 5px rgba(0, 0, 0, 0.3)', // a shadow effect
    borderRadius: '4px',
    padding: '5px',
    flexWrap: 'wrap', // Wrap items to the next line if needed
    alignItems: 'center', // Vertically center
    // border: '1px solid red',
  },
  skillIcon: {
    marginRight: '8px',
  },
  skillEntry: {
    marginRight: '8px',
    marginBottom: '5px',
    // border: '2px solid black',
  },
};

// Media query for mobile size
const mobileStyles = {
  skills: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  skillBox: {
    marginBottom: '5px',
  },
};

export default TypeBox;
